import React, { useCallback, useEffect, createContext, useState } from "react";
import allowedUserIds from "../pages/admin/adminConfig";
import axios from "axios";
import Env from "../runtimeEnv";
import { isDemoMode } from "../demo/demoMode";


export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [currentNickname, setCurrentNickname] = useState("");
  const [PlutonicuserID, setPlutonicuserID] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [userType, setUserType] = useState(localStorage.getItem("userType") || "");
  const [currentFormType, setCurrentFormType] = useState("login");
  const [loading, setLoading] = useState(true);
  const [showNewPasswordForm, setShowNewPasswordForm] = useState(false);
  const [therapistEmail, setTherapistEmail] = useState("");



  useEffect(() => {
    const storedNickname = localStorage.getItem("currentNickname");
    const storedUserID = localStorage.getItem("PlutonicuserID");
    const storedUserType = localStorage.getItem("userType");
        const storedEmail = localStorage.getItem("userEmail");







    if (storedNickname && storedUserID) {
      setCurrentNickname(storedNickname);
      setPlutonicuserID(storedUserID);
      setIsAuthenticated(true);
      setIsAdmin(
        allowedUserIds.includes(storedUserID) ||
        (isDemoMode && storedUserType?.toLowerCase() === "admin")
      );
    }

if (storedEmail) {
  setTherapistEmail(storedEmail);
}


    if (storedUserType) {
      setUserType(storedUserType);
    }

    // ✅ Once initialized, set loading to false
    setLoading(false);
  }, []);

  const handleLogout = useCallback(async () => {
    try {
      if (isDemoMode) return;
      const meetingID = sessionStorage.getItem("meetingID");
      const PlutonicuserID = localStorage.getItem("PlutonicuserID");

      if (meetingID && PlutonicuserID) {
        try {
          await axios.post(
            `${Env.REACT_APP_PYTHON_API_URL}/api/set-online-status/${PlutonicuserID}`,
            { meetingID, online: false },
            { withCredentials: true }
          );
        } catch (statusError) {
          console.warn("[App] Could not update online status during logout.");
        }
      }

      // console.log('[App] Logging out from Cognito...');
      await axios.post(
        `${Env.REACT_APP_PYTHON_API_URL}/api/logout`,
        {},
        { withCredentials: true }
      );
      // console.log('[App] Successfully logged out.');
    } catch (err) {
      if (err.response?.status === 500) {
        console.warn(
          "[App] Logout failed on the server, possibly due to expired token."
        );
      } else {
        console.error("[App] Failed during logout process:");
      }
    } finally {
      // console.log('[App] Clearing session and local storage.');
      localStorage.clear();
      sessionStorage.clear();
      setCurrentNickname("");
      setPlutonicuserID("");
      setCurrentFormType("login");
      setIsAuthenticated(false);
      setIsAdmin(false);
      setLoading(false); // Update loading to false
     
    }
  }, []);


  return (
    <AuthContext.Provider
      value={{
        currentNickname,
        setCurrentNickname,
        PlutonicuserID,
        setPlutonicuserID,
        isAuthenticated,
        setIsAuthenticated,
        isAdmin,
        setIsAdmin,
        userType,
        setUserType,
        currentFormType,
        setCurrentFormType,
        loading,
        setLoading,
        showNewPasswordForm,
  setShowNewPasswordForm,
        handleLogout,
        therapistEmail,      
setTherapistEmail,

      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
